import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type NoAccessEmptyStateProps = {
  message?: string;
};

/**
 * For pages with no acl access
 */
export const NoAccessEmptyState: React.FC<NoAccessEmptyStateProps> = ({ message }) => {
  return (
    <div css={containerStyle}>
      <div css={contentStyle}>
        <svg
          id='Layer_1'
          data-name='Layer 1'
          xmlns='http://www.w3.org/2000/svg'
          width='436'
          height='413'
          viewBox='0 0 436 413'
          css={{ padding: theme.spacing(0, 1) }}
        >
          <g clipPath='url(#clip0_3900_20314)'>
            <path
              d='M340.327 19.3208H95.7488C57.4522 19.3208 26.4067 50.3663 26.4067 88.6628V333.241C26.4067 371.537 57.4522 402.583 95.7488 402.583H340.327C378.623 402.583 409.669 371.537 409.669 333.241V88.6628C409.669 50.3663 378.623 19.3208 340.327 19.3208Z'
              fill='#EBF3FF'
            />
            <path
              d='M346.33 98.871H120.864C107.518 98.871 96.6987 109.69 96.6987 123.036V329.353C96.6987 342.699 107.518 353.518 120.864 353.518H346.33C359.676 353.518 370.495 342.699 370.495 329.353V123.036C370.495 109.69 359.676 98.871 346.33 98.871Z'
              fill='#DCEBFE'
            />
            <path
              d='M354.74 305.846C340.998 305.846 330.169 316.966 330.169 330.416C330.169 343.867 341.289 354.987 354.74 354.987C368.19 354.987 379.31 343.867 379.31 330.416C379.31 316.966 368.494 305.846 354.74 305.846Z'
              fill='#9EC5FF'
            />
            <path
              d='M430.871 316.814L421.359 314.091C418.978 313.407 417.281 311.71 416.268 309.329C415.254 306.948 414.57 304.567 413.215 302.198C412.202 300.159 412.202 297.436 413.215 295.397L417.977 286.557C419.674 283.504 418.991 280.098 416.622 277.716L407.453 268.547C405.413 265.824 402.019 265.153 398.954 266.85L390.114 271.612C388.075 272.625 385.352 272.625 383.313 271.612C380.932 270.599 378.551 269.573 376.182 268.56C373.801 267.876 372.104 265.836 371.42 263.468L368.368 254.299C367.684 251.246 364.631 248.865 361.237 248.865H348.319C344.924 248.865 341.859 251.246 341.188 254.299L338.465 263.81C337.781 266.191 336.084 267.888 333.703 268.901C331.322 269.915 328.941 270.599 326.573 271.954C324.533 272.967 321.81 272.967 319.771 271.954L310.602 266.862C307.549 265.165 304.142 265.849 301.761 268.218L292.592 277.387C290.211 279.768 289.539 283.163 291.237 286.227L295.999 295.068C297.012 297.107 297.012 299.83 295.999 301.869C294.985 304.25 293.96 306.631 292.946 309C292.262 311.381 290.223 313.078 287.855 313.762L278.685 316.814C275.633 317.498 273.252 320.55 273.252 323.945V336.863C273.252 340.257 275.633 343.322 278.685 343.994L288.197 346.717C290.578 347.4 292.275 349.098 293.288 351.479C294.302 353.86 294.985 356.241 296.341 358.609C297.354 360.648 297.354 363.371 296.341 365.41L291.249 374.58C289.552 377.632 290.236 381.039 292.604 383.42L301.774 392.59C304.155 394.971 307.891 395.313 310.614 393.945L319.455 389.183C321.494 388.17 324.217 388.17 326.256 389.183C328.637 390.196 331.018 391.222 333.386 392.235C335.767 392.919 337.465 394.958 338.148 397.327L340.872 406.838C341.885 409.891 344.608 412.272 348.002 412.272H360.921C364.315 412.272 367.38 409.891 368.051 406.838L370.774 397.327C371.458 394.946 373.155 393.249 375.536 392.235C377.917 391.222 380.298 390.538 382.667 389.183C384.706 388.17 387.429 388.17 389.468 389.183L398.308 393.945C401.361 395.642 404.768 394.958 407.149 392.59L416.318 383.42C418.699 381.039 419.041 377.303 417.673 374.58L412.911 365.74C411.898 363.701 411.898 360.978 412.911 358.938C413.924 356.557 414.95 354.176 415.964 351.808C416.648 349.427 418.687 347.73 421.055 347.046L430.567 344.323C433.619 343.31 436 340.587 436 337.192V324.274C436.342 320.538 433.961 317.473 430.909 316.801L430.871 316.814ZM354.74 374.935C330.271 374.935 310.222 354.886 310.222 330.416C310.222 305.947 330.271 285.898 354.74 285.898C379.209 285.898 399.258 305.947 399.258 330.416C399.258 354.886 379.209 374.935 354.74 374.935Z'
              fill='#9EC5FF'
            />
            <path
              d='M81.5642 57.6837C67.8224 57.6837 56.9937 68.8038 56.9937 82.2542C56.9937 95.7047 68.1137 106.825 81.5642 106.825C95.0146 106.825 106.135 95.7047 106.135 82.2542C106.135 68.8038 95.3186 57.6837 81.5642 57.6837Z'
              fill='#9EC5FF'
            />
            <path
              d='M157.682 68.6518L148.17 65.9288C145.789 65.2449 144.092 63.5477 143.079 61.1667C142.066 58.7856 141.382 56.4046 140.027 54.0362C139.014 51.9971 139.014 49.274 140.027 47.2349L144.789 38.3946C146.486 35.3423 145.802 31.9354 143.434 29.5543L134.264 20.3847C132.225 17.6617 128.831 16.9904 125.766 18.6875L116.925 23.4497C114.886 24.4629 112.163 24.4629 110.124 23.4497C107.743 22.4364 105.362 21.4106 102.994 20.3974C100.613 19.7134 98.9155 17.6743 98.2315 15.3059L95.1792 6.13632C94.4953 3.084 91.443 0.702942 88.0487 0.702942H75.1302C71.7359 0.702942 68.6709 3.084 67.9997 6.13632L65.2767 15.6479C64.5928 18.029 62.8956 19.7261 60.5145 20.7393C58.1335 21.7525 55.7524 22.4364 53.384 23.7916C51.3449 24.8048 48.6219 24.8048 46.5828 23.7916L37.4132 18.7002C34.3609 17.0031 30.9539 17.687 28.5729 20.0554L19.4033 29.225C17.0222 31.6061 16.3509 35.0003 18.0481 38.0653L22.8102 46.9056C23.8234 48.9447 23.8234 51.6678 22.8102 53.7069C21.797 56.0879 20.7711 58.469 19.7579 60.8374C19.074 63.2184 17.0349 64.9156 14.6665 65.5995L5.49685 68.6518C2.44454 69.3357 0.0634766 72.3881 0.0634766 75.7823V88.7008C0.0634766 92.0951 2.44454 95.1601 5.49685 95.8314L15.0084 98.5544C17.3895 99.2383 19.0866 100.935 20.0998 103.317C21.1131 105.698 21.797 108.079 23.1522 110.447C24.1654 112.486 24.1654 115.209 23.1522 117.248L18.0607 126.418C16.3636 129.47 17.0475 132.877 19.4159 135.258L28.5855 144.428C30.9666 146.809 34.7028 147.151 37.4259 145.783L46.2662 141.021C48.3053 140.008 51.0283 140.008 53.0674 141.021C55.4485 142.034 57.8295 143.06 60.1979 144.073C62.579 144.757 64.2761 146.796 64.96 149.165L67.6831 158.676C68.6963 161.728 71.4193 164.11 74.8136 164.11H87.7321C91.1264 164.11 94.1914 161.728 94.8626 158.676L97.5856 149.165C98.2695 146.784 99.9667 145.086 102.348 144.073C104.729 143.06 107.11 142.376 109.478 141.021C111.517 140.008 114.24 140.008 116.279 141.021L125.12 145.783C128.172 147.48 131.579 146.796 133.96 144.428L143.13 135.258C145.511 132.877 145.853 129.141 144.485 126.418L139.723 117.578C138.71 115.538 138.71 112.815 139.723 110.776C140.736 108.395 141.762 106.014 142.775 103.646C143.459 101.265 145.498 99.5676 147.867 98.8837L157.378 96.1607C160.43 95.1474 162.811 92.4244 162.811 89.0301V76.1116C163.153 72.3754 160.772 69.3104 157.72 68.6392L157.682 68.6518ZM81.5641 126.772C57.0949 126.772 37.0459 106.723 37.0459 82.2543C37.0459 57.7851 57.0949 37.736 81.5641 37.736C106.033 37.736 126.082 57.7851 126.082 82.2543C126.082 106.723 106.033 126.772 81.5641 126.772Z'
              fill='#9EC5FF'
            />
            <path
              d='M333.754 80.1898H102.322C88.6196 80.1898 77.5112 91.2982 77.5112 105.001V316.789C77.5112 330.492 88.6196 341.6 102.322 341.6H333.754C347.457 341.6 358.565 330.492 358.565 316.789V105.001C358.565 91.2982 347.457 80.1898 333.754 80.1898Z'
              fill='white'
            />
            <path
              d='M102.31 80.1898H333.754C347.445 80.1898 358.565 91.3099 358.565 105.001V114.259H77.5112V105.001C77.5112 91.3099 88.6313 80.1898 102.322 80.1898H102.31Z'
              fill='#C2F4F1'
            />
            <path
              d='M155.212 159.043H307.093C316.199 159.043 323.596 166.44 323.596 175.546C323.596 184.653 316.199 192.049 307.093 192.049H155.212V159.043Z'
              fill='#6BA6FF'
            />
            <path
              d='M143.053 141.502C129.616 141.502 118.027 149.304 112.492 160.614H143.408V190.466H112.492C118.027 201.776 129.616 209.578 143.053 209.578C161.849 209.578 177.097 194.341 177.097 175.534C177.097 156.726 161.861 141.49 143.053 141.49V141.502Z'
              fill='#6BA6FF'
            />
            <path
              d='M148.423 103.456C151.683 103.456 154.325 100.813 154.325 97.5538C154.325 94.2942 151.683 91.6518 148.423 91.6518C145.164 91.6518 142.521 94.2942 142.521 97.5538C142.521 100.813 145.164 103.456 148.423 103.456Z'
              fill='white'
            />
            <path
              d='M125.512 103.456C128.772 103.456 131.414 100.813 131.414 97.5538C131.414 94.2942 128.772 91.6518 125.512 91.6518C122.253 91.6518 119.61 94.2942 119.61 97.5538C119.61 100.813 122.253 103.456 125.512 103.456Z'
              fill='white'
            />
            <path
              d='M102.588 103.456C105.848 103.456 108.49 100.813 108.49 97.5538C108.49 94.2942 105.848 91.6518 102.588 91.6518C99.3285 91.6518 96.686 94.2942 96.686 97.5538C96.686 100.813 99.3285 103.456 102.588 103.456Z'
              fill='white'
            />
            <path
              d='M128.21 231.45H307.701'
              stroke='#DCEBFE'
              strokeWidth='7.76'
              strokeMiterlimit='3'
              strokeLinecap='round'
            />
            <path
              d='M142.281 251.132H293.618'
              stroke='#DCEBFE'
              strokeWidth='7.76'
              strokeMiterlimit='3'
              strokeLinecap='round'
            />
            <path
              d='M128.21 286.861H307.701'
              stroke='#DCEBFE'
              strokeWidth='7.76'
              strokeMiterlimit='3'
              strokeLinecap='round'
            />
            <path
              d='M142.281 306.542H293.618'
              stroke='#DCEBFE'
              strokeWidth='7.76'
              strokeMiterlimit='3'
              strokeLinecap='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_3900_20314'>
              <rect width='436' height='411.619' fill='white' transform='translate(0 0.690247)' />
            </clipPath>
          </defs>
        </svg>
        {message && (
          <Text textAlign='center' css={{ color: theme.colors.neutral50, padding: theme.spacing(0, 1.5) }}>
            {message}
          </Text>
        )}
      </div>
    </div>
  );
};

const containerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const contentStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${theme.spacing(4)};
`;
